import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCnuI3T0HQN1PyJ-V7Sj568sD08XeeTYBE",
  authDomain: "streamflix-gpt-f5fd8.firebaseapp.com",
  projectId: "streamflix-gpt-f5fd8",
  storageBucket: "streamflix-gpt-f5fd8.firebasestorage.app",
  messagingSenderId: "667306208407",
  appId: "1:667306208407:web:7a8b5e1d8fc3b9b7d40dd2",
  measurementId: "G-Q2EKJC2G9R"
};

initializeApp(firebaseConfig);
export const auth=getAuth()